import type { StipDocument } from '../../types';

interface ContactDocumentsProps {
  documents: StipDocument[];
  renderDocumentForm: (documents: StipDocument[]) => React.ReactNode;
}

export default function ContactDocuments({ documents, renderDocumentForm }: ContactDocumentsProps): React.ReactNode {
  if (documents.length === 0) {
    return null;
  }

  return <>{renderDocumentForm(documents)}</>;
}
